// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1gQ2g","large":"styles_large__ijmZE"};